const app = document.getElementById("salt-hair-quiz");

let step = -1;
let answers = {};

const PRODUCTS = {
  hybridHair: {
    name: "Hybrid Hair",
    role: "Primary Styler",
    desc: "Your all-round daily styling solution. Versatile hold with a natural finish — designed for reworkability without compromising on performance.",
    handle: "hybrid-hair"
  },

  compoundClay: {
    name: "Compound Clay",
    role: "Primary Styler",
    desc: "Maximum hold with a dry matte finish. Engineered for structure, grip, and definition.",
    handle: "compound-clay"
  },

  fusionWax: {
    name: "Fusion Wax",
    role: "Primary Styler",
    desc: "Precision plant-based wax for sculpted, controlled styles with a low-shine finish.",
    handle: "fusion-wax"
  },

  marineMist: {
    name: "Marine Mist",
    role: "Texture & Volume",
    desc: "Lightweight sea salt spray that adds volume, texture, and movement.",
    handle: "marine-mist"
  },

  thickeningDuo: {
    name: "Thickening Shampoo & Conditioner",
    role: "Wash System",
    desc: "Engineered to strengthen, fortify, and visibly thicken.",
    handle: "thickening-shampoo-conditioner-set"
  },
  moisturisingDuo: {
    name: "Moisturising Shampoo & Conditioner",
    role: "Wash System",
    desc: "Deep nourishment and repair for dry or damaged hair.",
    handle: "moisturising-shampoo-conditioner-set"
  },

  growthSerum: {
    name: "Advanced Hair Growth Serum",
    role: "Treatment",
    desc: "Clinically proven treatment designed to reverse hair loss and promote thicker hair.",
    handle: "advanced-hair-growth-serum"
  }
};

const QUESTIONS = [
  {
    id: "length",
    step: "01 / 07",
    category: "Hair Profile",
    title: "How long is your hair?",
    subtitle: "This helps us identify which styling products are suited to your length.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/Hair_Length.jpg?v=1780651663",
    twoCol: true,
    options: [
      {
        value: "short",
        label: "Short",
        desc: "Cropped, faded, or close-cut styles"
      },
      {
        value: "medium",
        label: "Medium",
        desc: "Textured crops, fringes, side parts"
      },
      {
        value: "long",
        label: "Long",
        desc: "Shoulder length or beyond"
      }
    ]
  },

  {
    id: "thickness",
    step: "02 / 07",
    category: "Hair Profile",
    title: "How would you describe your hair thickness?",
    subtitle: "Individual strand thickness — not volume or density.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/Hair_Thickness.jpg?v=1780651665",
    twoCol: true,
    options: [
      {
        value: "fine",
        label: "Fine",
        desc: "Strands feel delicate, hair can feel flat"
      },
      {
        value: "medium",
        label: "Medium",
        desc: "Not noticeably fine or thick"
      },
      {
        value: "thick",
        label: "Thick",
        desc: "Dense, strong strands with good body"
      }
    ]
  },

  {
    id: "scalp",
    step: "03 / 07",
    category: "Hair Profile",
    title: "How does your scalp typically feel?",
    subtitle: "This determines your ideal cleansing and conditioning system.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/Scalp_Quality.jpg?v=1780651663",
    twoCol: false,
    options: [
      {
        value: "dry",
        label: "Dry",
        desc: "Tight, flaky, or itchy — needs moisture"
      },
      {
        value: "normal",
        label: "Normal",
        desc: "Balanced — no specific issues"
      },
      {
        value: "oily",
        label: "Oily",
        desc: "Gets greasy quickly, needs regular washing"
      }
    ]
  },

  {
    id: "concern",
    step: "04 / 07",
    category: "Concerns",
    title: "What's your primary hair concern?",
    subtitle: "Pick the one that matters most to you right now.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/Primary_Concern.jpg?v=1780651663",
    twoCol: false,
    options: [
      {
        value: "thinning",
        label: "Thinning or hair loss",
        desc: "Noticeably less density, receding, or shedding"
      },
      {
        value: "dryness",
        label: "Dryness or damage",
        desc: "Brittle, rough, or lacking moisture"
      },
      {
        value: "volume",
        label: "Lack of volume",
        desc: "Flat, limp, or lacking body"
      },
      {
        value: "none",
        label: "No specific concern",
        desc: "Just looking for the right everyday routine"
      }
    ]
  },

  {
    id: "finish",
    step: "05 / 07",
    category: "Styling",
    title: "What finish do you prefer?",
    subtitle: "The look you're going for when your hair is styled.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/What_Finish.jpg?v=1780651663",
    twoCol: false,
    options: [
      {
        value: "matte",
        label: "Matte",
        desc: "Dry, natural-looking — no shine at all"
      },
      {
        value: "natural",
        label: "Natural",
        desc: "Healthy, lived-in — a hint of life"
      },
      {
        value: "low-shine",
        label: "Low Shine",
        desc: "Polished, refined — controlled without grease"
      },
      {
        value: "texture",
        label: "Texture only",
        desc: "Volume and movement — no hold needed"
      }
    ]
  },

  {
    id: "hold",
    step: "06 / 07",
    category: "Styling",
    title: "How much hold do you need?",
    subtitle: "How structured and locked-in do you want your style to be?",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/How_Much_Hold.jpg?v=1780651662",
    twoCol: false,
    options: [
      {
        value: "light",
        label: "Light",
        desc: "Flexible, moveable — effortless and relaxed"
      },
      {
        value: "medium",
        label: "Medium",
        desc: "Controlled but reworkable"
      },
      {
        value: "high",
        label: "High",
        desc: "Strong hold that lasts"
      },
      {
        value: "maximum",
        label: "Maximum",
        desc: "Firm, structured control"
      }
    ]
  },

  {
    id: "routine",
    step: "07 / 07",
    category: "Routine",
    title: "How do you approach your routine?",
    subtitle: "This tells us how many products to include.",
    image: "https://cdn.shopify.com/s/files/1/0170/3952/3904/files/Routine.jpg?v=1780651663",
    twoCol: false,
    options: [
      {
        value: "minimal",
        label: "Minimal",
        desc: "1–2 products — fast and simple"
      },
      {
        value: "balanced",
        label: "Balanced",
        desc: "2–3 products — performance with ease"
      },
      {
        value: "full",
        label: "Full Routine",
        desc: "4–5 products — complete optimisation"
      }
    ]
  }
];

function getPrimaryStyler(answers) {
  const { hold, finish, length } = answers;

  if (hold === "maximum") {
    return { ...PRODUCTS.compoundClay };
  }

  if (finish === "texture" || hold === "light") {
    return { ...PRODUCTS.marineMist };
  }

  if (finish === "matte") {
    return { ...PRODUCTS.compoundClay };
  }

  if (finish === "low-shine") {
    return { ...PRODUCTS.fusionWax };
  }

  if (finish === "natural") {
    return { ...PRODUCTS.hybridHair };
  }

  if (hold === "medium") {
    return length === "long"
      ? { ...PRODUCTS.fusionWax }
      : { ...PRODUCTS.hybridHair };
  }

  return { ...PRODUCTS.hybridHair };
}

function getWashSystem(answers) {
  const { scalp, concern, thickness } = answers;

  if (scalp === "dry") {
    return { ...PRODUCTS.moisturisingDuo };
  }

  if (
    concern === "thinning" ||
    concern === "volume" ||
    thickness === "fine"
  ) {
    return { ...PRODUCTS.thickeningDuo };
  }

  if (concern === "dryness") {
    return { ...PRODUCTS.moisturisingDuo };
  }

  return thickness === "thick"
    ? { ...PRODUCTS.moisturisingDuo }
    : { ...PRODUCTS.thickeningDuo };
}

function buildRoutine(answers) {
  const { routine, thickness, concern } = answers;

  const primaryStyler = getPrimaryStyler(answers);
  const washSystem = getWashSystem(answers);

  const includeSerum =
    concern === "thinning" || thickness === "fine";

  const addMist =
    (thickness === "fine" || concern === "volume") &&
    primaryStyler.name !== "Marine Mist";

  let items = [];

  if (routine === "minimal") {

    items.push(primaryStyler);

    if (addMist) {
      items.push({
        ...PRODUCTS.marineMist,
        role: "Pre-Styler"
      });
    }

  } else if (routine === "balanced") {

    items.push(primaryStyler);
    items.push(washSystem);

    if (addMist) {
      items.push({
        ...PRODUCTS.marineMist,
        role: "Pre-Styler"
      });
    }

  } else {

    items.push(washSystem);
    items.push(primaryStyler);

    if (primaryStyler.name !== "Marine Mist") {
      items.push({
        ...PRODUCTS.marineMist,
        role: "Pre-Styler"
      });
    }

    if (primaryStyler.name === "Marine Mist") {
      items.push({
        ...PRODUCTS.hybridHair,
        role: "Secondary Styler"
      });
    }

    if (includeSerum) {
      items.push({
        ...PRODUCTS.growthSerum
      });
    }
  }

  const seen = new Set();

  items = items.filter((p) => {
    if (seen.has(p.name)) {
      return false;
    }

    seen.add(p.name);
    return true;
  });

  if (
    includeSerum &&
    !items.find(
      (p) => p.name === PRODUCTS.growthSerum.name
    )
  ) {
    items.push({
      ...PRODUCTS.growthSerum
    });
  }

  return items;
}

function updateProgress() {
  const progress = document.querySelector(".salt-progress-fill");

  if (!progress) return;

  const totalSteps = QUESTIONS.length;

  const value =
    step < 0
      ? 0
      : step === totalSteps
      ? 100
      : (step / totalSteps) * 100;

  progress.style.width = `${value}%`;
}

function renderIntro() {

  app.innerHTML = `
    <div class="salt-quiz">
      <div class="salt-progress-wrap">
        <div class="salt-progress-fill"></div>
      </div>

      <main class="salt-main">

        <div class="salt-screen">

        
        </div>

      </main>

    </div>
  `;

  updateProgress();

  document
    .querySelector(".salt-btn-start")
    .addEventListener("click", () => {

    document.getElementById("salt-hair-quiz").style.display = "block";

    const mainSection = document.querySelector(".shopify-section--image-with-text-overlay");
    const footerSection = document.querySelector(".shopify-section--footer");
    const headerClass = document.querySelector(".header"); 
    const multi = document.querySelector(".shopify-section--multi-column");

    if (headerClass) {
      headerClass.classList.add("is-solid");
    }
    if (footerSection) {
      footerSection.style.display = "none";
    }
    if (mainSection) {
      mainSection.style.display = "none";
    }
    if (multi) {
      multi.style.display = "none";
    }
      step = 0;
      render();
    });
}

function renderQuestion() {
  const question = QUESTIONS[step];

  app.innerHTML = `
    <div class="salt-quiz ">

      <div class="salt-step-label">
            <span class="font-light">${question.step} </span> — ${question.category}
      </div>
      <div class="salt-progress-wrap">
        <div class="salt-progress-fill"></div>
      </div>

      <main class="salt-main">

        <div class="salt-screen">
        <div class="salt-ques-header">
          <h2 class="salt-question-title h2">
            ${question.title}
          </h2>
          <p class="salt-question-subtitle">
            ${question.subtitle}
          </p>
          </div>
          <div class="quiz-image">
            <img
              src="${question.image}"
              alt="${question.title}"
              width="511"
              height="384"
              loading="lazy"
            >
          </div>
          

          <div class="salt-options-grid ${question.twoCol ? "two-col" : ""}">

            ${question.options.map((option) => `
              <button
                class="salt-option-btn ${answers[question.id] === option.value ? "selected" : ""}"
                data-value="${option.value}"
              >

                <span class="salt-opt-label">
                  ${option.label}
                </span>

                <span class="salt-opt-desc text-xs">
                  ${option.desc}
                </span>

                <span class="salt-option-check">
                  ${answers[question.id] === option.value ? "✓" : ""}
                </span>

              </button>
            `).join("")}

          </div>

          

        </div>
        <div class="salt-nav">

            <button class="salt-btn-back button button--outline">
              ← Back
            </button>

            <button
              class="salt-btn-next button button--solid"
              ${answers[question.id] ? "" : "disabled"}
            >
              ${step === QUESTIONS.length - 1
                ? "See My Prescription →"
                : "Next →"}
            </button>

          </div>
      </main>

    </div>
  `;

  updateProgress();

  const optionButtons =
    document.querySelectorAll(".salt-option-btn");

  optionButtons.forEach((btn) => {

    btn.addEventListener("click", () => {

      optionButtons.forEach((b) => {
        b.classList.remove("selected");

        const check = b.querySelector(".salt-option-check");

        if (check) {
          check.innerHTML = "";
        }
      });

      btn.classList.add("selected");

      const check = btn.querySelector(".salt-option-check");

      if (check) {
        check.innerHTML = "✓";
      }

      answers[question.id] = btn.dataset.value;

      document
        .querySelector(".salt-btn-next")
        .disabled = false;
        // Auto go to next step
        setTimeout(() => {
          step++;
          render();
        }, 250);
            });
  });

  document
    .querySelector(".salt-btn-next")
    .addEventListener("click", () => {
      step++;
      render();
    });

  document
    .querySelector(".salt-btn-back")
    .addEventListener("click", () => {

      if (step <= 0) {
        step = -1;
        document.getElementById("salt-hair-quiz").style.display = "none";

      const overlay = document.querySelector(
        ".shopify-section--image-with-text-overlay"
      );
       const headerClass = document.querySelector(".header");
       const footerClass = document.querySelector(".shopify-section--footer")

        if (headerClass) {
          headerClass.classList.remove("is-solid");
        }

      if (overlay) {
        overlay.style.display = "block";
      }

      const multi = document.querySelector(
        ".shopify-section--multi-column"
      );

      if (multi) {
        multi.style.display = "block";
      }
      if (footerClass) {
        footerClass.style.display = "block";
      }
      } else {
        step--;
      }

      render();
    });
}

async function updateTotalPrices(routine) {

  let totalPrice = 0;
  let totalComparePrice = 0;

  for (const product of routine) {

    try {

      const response = await fetch(
        `/products/${product.handle}.js`
      );

      const productData = await response.json();

      const variant = productData.variants[0];

      totalPrice += variant.price;

      totalComparePrice +=
        variant.compare_at_price || variant.price;

    } catch (error) {

      console.error(
        `Failed price fetch for ${product.handle}`,
        error
      );

    }

  }

  const currency =
    document.body.dataset.country || 'USD';

  const formattedTotal =
    (totalPrice / 100).toLocaleString(
      'en-US',
      {
        style: 'currency',
        currency: document.body.dataset.country || 'USD',
        currencyDisplay: 'narrowSymbol'
      }
    );

  const formattedCompare =
    (totalComparePrice / 100).toLocaleString(
      'en-US',
      {
        style: 'currency',
        currency: document.body.dataset.country || 'USD',
        currencyDisplay: 'narrowSymbol'
      }
    );


    const savings =
      totalComparePrice - totalPrice;

    const resultPrice =
    document.querySelector(".result-price");


    const hasDiscount =
    totalComparePrice > totalPrice;

    const savingsPercent =
    hasDiscount
    ? Math.round(
        (savings / totalComparePrice) * 100
      )
    : 0;

resultPrice.innerHTML = `
  ${hasDiscount ? `
    <on-sale-badge class="badge badge--on-sale">
       Save ${savingsPercent}%
    </on-sale-badge>
  ` : ''}
  <price-list class="price-list">
    <sale-price class="text-sm ${hasDiscount ? 'text-on-sale' : ''}">
      <span class="sr-only">
        Sale price
      </span>
      ${formattedTotal}
    </sale-price>
    ${hasDiscount ? `
      <compare-at-price class="text-sm text-subdued line-through">
        <span class="sr-only">
          Regular price
        </span>

        ${formattedCompare}
      </compare-at-price>
    ` : ''}
  </price-list>
`;
}
function renderResults() {
  const routine = buildRoutine(answers);

  const wash = routine.filter(
    (p) => p.role === "Wash System"
  );

  const styling = routine.filter((p) =>
    [
      "Primary Styler",
      "Secondary Styler",
      "Texture & Volume",
      "Pre-Styler"
    ].includes(p.role)
  );

  const treatment = routine.filter(
    (p) => p.role === "Treatment"
  );

   const routineTitle = {
  minimal: "Minimal",
  balanced: "Balanced",
  full: "Full Routine"
}[answers.routine] || "Routine";

  app.innerHTML = `
    <div class="salt-quiz salt-quiz--results">

      <div class="salt-progress-wrap">
        <div class="salt-progress-fill"></div>
      </div>

      <div class="salt-main">
          <div class="salt-result-header">

            <span class="salt-result-eyebrow h1">
              Your Prescription
            </span>

            <p class="salt-result-title h3">
                 ${routineTitle}
            </p>
            <button class="salt-btn-retake">
              Retake Quiz
            </button>

          </div>
        <div class="salt-screen salt-results-screen">

          ${[
            { label: "Wash & Care", products: wash },
            { label: "Styling", products: styling },
            { label: "Treatment", products: treatment }
          ]
          .filter(section => section.products.length)
          .map((section, index) =>
            renderSection(
              section.label,
              section.products,
              index
            )
          )
          .join("")}

        </div>

        <div class="salt-result-actions">
            <div class="result-actions-left">
            <h3 class="h3">My Prescription</h3>
          </div>
          <div class="result-actions-right">
              <div class="products_count text-sm">${routine.length} items</div>
              <div class="result-price"> </div>
            <button class="salt-btn-shopATC button">
              Add all to cart →
            </button>
            </div>

          </div>

      </div>

    </div>
  `;

  updateProgress();
  updateTotalPrices(routine);

  document
  .querySelectorAll(".salt-btn-shop")
  .forEach((button) => {

    button.addEventListener(
      "click",
      async () => {

        try {

          const handle =
            button.dataset.handle;

          const response = await fetch(
            `/products/${handle}.js`
          );

          const productData =
            await response.json();

          const variantId =
            productData.variants[0].id;

          await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1
                }
              ]
            })
          });

          document.dispatchEvent(
            new CustomEvent(
              "cart:refresh"
            )
          );

          const cartButton =
            document.querySelector(
              '.header__cart-link a'
            );

          if (cartButton) {
            cartButton.click();
          }

        } catch (error) {

          console.error(
            "Single product add failed",
            error
          );

        }

      }
    );

  });

  document
    .querySelector(".salt-btn-retake")
    .addEventListener("click", () => {
      step = -1;
      document.getElementById("salt-hair-quiz").style.display = "none";

      const overlay = document.querySelector(
        ".shopify-section--image-with-text-overlay"
      );

      if (overlay) {
        overlay.style.display = "block";
      }

      const multi = document.querySelector(
        ".shopify-section--multi-column"
      );

      if (multi) {
        multi.style.display = "block";
      }
      answers = {};
      render();
    });



document
  .querySelector(".salt-btn-shopATC")
  .addEventListener("click", async () => {

    try {

      const items = [];

      for (const product of routine) {

        const response = await fetch(
          `/products/${product.handle}.js`
        );

        const productData = await response.json();

        if (
          productData.variants &&
          productData.variants.length
        ) {

          items.push({
            id: productData.variants[0].id,
            quantity: 1
          });

        }
      }

      if (!items.length) {
        return;
      }

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });

       document.dispatchEvent(
        new CustomEvent("cart:refresh")
      );
      const cartButton = document.querySelector(
      '.header__cart-link a'
      );

      if (cartButton) {
      cartButton.click();
      }

    } catch (error) {

      console.error(
        "Failed to add routine to cart",
        error
      );

    }

  });

}
function renderSection(label, products, number) {

  if (!products.length) {
    return "";
  }

  products.forEach((product) => {

    fetch(`/products/${product.handle}.js`)
      .then(response => response.json())
      .then(productData => {

        const imageEl = document.querySelector(
          `.salt-product-image-${product.handle}`
        );
        const priceEl = document.querySelector(
          `.salt-product-price-${product.handle}`
        );

        if (imageEl) {

          imageEl.innerHTML = `
          <a href="/products/${product.handle}" target="_blank">
            <img
              src="${productData.featured_image}"
              alt="${product.name}"
              loading="lazy"
              height= "85"
              width= "85"
            />
            </a>
          `;
        }
        if (priceEl) {

          const formattedPrice =
          (productData.price / 100).toLocaleString(
            'en-US',
            {
              style: 'currency',
              currency: document.body.dataset.country || 'USD',
              currencyDisplay: 'narrowSymbol'
            }
          );

          priceEl.innerHTML = `
            <span> ${formattedPrice}</span>
          `;
        }

      });

  });

  return `
    <div class="salt-routine-section">

      <span class="salt-section-label h2">
        0${number + 1} - ${label}
      </span>

      ${products.map((product) => `

        <div class="salt-product-card">

          <div class="salt-product-info">

            <span class="salt-product-role font-light">
              ${product.role}
            </span>
            <p class="salt-product-desc">
              ${product.desc}
            </p>
            <div class="product_card">
            <div class="salt-product-image salt-product-image-${product.handle}">
            </div>
            <div class="pro_card-info">
              <span class="salt-product-name">
                ${product.name}
              </span>
              <div class="salt-product-price salt-product-price-${product.handle}">
              </div>
            </div>
            <button
              class="salt-btn-shop button"
              data-handle="${product.handle}"
        
            >
            <button-content class="button__content">Add to cart</button-content>
              
            </button>
            </div>

          </div>

        </div>

      `).join("")}

    </div>
  `;
}

function render() {

  if (step === -1) {
    renderIntro();
    return;
  }

  if (step < QUESTIONS.length) {
    renderQuestion();
    return;
  }

  renderResults();
}

render();